var _path, _path2, _path3, _path4, _path5, _circle, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPersonPoutingSvgrepoCom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36px",
    height: "36px",
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-hidden": "true",
    role: "img",
    className: "iconify iconify--twemoji",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FA743E",
    d: "M27 27H9a4 4 0 0 0-4 4v5h26v-5a4 4 0 0 0-4-4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#DD551F",
    d: "M9 32h1v4H9zm17 0h1v4h-1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFAC33",
    d: "M21.906 1.262c-2.02-.654-6.772-.475-7.96 1.069c-3.089.059-6.713 2.851-7.188 6.535c-.47 3.645.578 5.338.951 8.079c.422 3.106 2.168 4.099 3.564 4.515C13.281 24.114 15.415 24 19 24c7 0 10.334-4.684 10.629-12.639c.178-4.812-2.645-8.456-7.723-10.099z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFDC5D",
    d: "M15 22v6a3 3 0 1 0 6 0v-6h-6z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFDC5D",
    d: "M25.909 11.701c-.677-.938-1.545-1.693-3.446-1.96c.713.327 1.396 1.455 1.485 2.079c.089.624.178 1.129-.386.505c-2.26-2.499-4.722-1.515-7.162-3.041c-1.704-1.066-2.223-2.246-2.223-2.246s-.208 1.574-2.792 3.178c-.749.465-1.643 1.5-2.139 3.03C8.889 14.345 9 15.325 9 17c0 4.889 4.029 9 9 9s9-4.147 9-9c0-3.041-.319-4.229-1.091-5.299z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#C1694F",
    cx: 18,
    cy: 23,
    r: 1
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#662113",
    d: "M14 16a1 1 0 0 1-1-1v-1a1 1 0 0 1 2 0v1a1 1 0 0 1-1 1zm8 0a1 1 0 0 1-1-1v-1a1 1 0 0 1 2 0v1a1 1 0 0 1-1 1z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#C1694F",
    d: "M19 19.5h-2a.5.5 0 0 1 0-1h2a.5.5 0 0 1 0 1z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonPoutingSvgrepoCom);
export default __webpack_public_path__ + "static/media/person-pouting-svgrepo-com.ffb3ab20c387ab2a9dd520520272c2c5.svg";
export { ForwardRef as ReactComponent };